import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { GeneralService } from "src/app/Service/general.service";
import { SubscriptionPlanComponent } from "src/app/user/subscription-plan/subscription-plan.component";
import Swal from "sweetalert2";
import { AddServicesComponent } from "../add-services/add-services.component";
import { data } from "jquery";
// import { ViewPropertyServicesComponent } from '../view-property-services/view-property-services.component';
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-view-services",
  templateUrl: "./view-services.component.html",
  styleUrls: ["./view-services.component.scss"],
})
export class ViewServicesComponent implements OnInit {
  @ViewChild("content", { static: false }) content: TemplateRef<any>;
  currentUser: any;
  isLoading: boolean = false;
  callAlertForm: FormGroup;
  usersData: any;
  userId: any;
  callAlertTypes: any[] = [];
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  breadCrumbItems: Array<{}>;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private service: GeneralService,
    private http: HttpClient,
    private datePipe: DatePipe,
    private fb: FormBuilder
  ) {
    if (this.router.getCurrentNavigation()) {
      if (this.router.getCurrentNavigation().extras.state) {
        const state = this.router.getCurrentNavigation().extras.state;
        this.userId = state["id"];
      } else {
        console.log(
          "localStorage.getItem('UserId')",
          localStorage.getItem("UserId")
        );
        if (localStorage.getItem("UserId")) {
          this.userId = localStorage.getItem("UserId");
          this.router.navigate(
            ["/users/users-users-details/services-interest"],
            {
              state: { id: localStorage.getItem("UserId") },
            }
          );
        } else {
          this.router.navigate(["/users/users-users"]);
        }
      }
    }
  }

  ngOnInit() {
    this.currentUser = this.service.getcurrentUser();
    this.getCallAlertType();
    this.callAlertForm = this.fb.group({
      call_alert_type_id: new FormControl(null, Validators.required),
      call_type: new FormControl(null, Validators.required),
      reference_source: new FormControl(null, Validators.required),
      priority: new FormControl(null, Validators.required),
      follow_up_date: new FormControl(Date, Validators.required),
      call_remarks: new FormControl(null, Validators.required),
    });
    if (this.userId) {
      this.getUsersCallDetails();
    } else {
      this.router.navigate(["/users/users-user"]);
    }

    this.breadCrumbItems = [
      { label: "Users List", path: "/users/users-users" },
      { label: "User Details", path: "/users/users-users-details" },
      {
        label: "Services Interested",
        path: "/users-users-details/services-interest",
        active: true,
      },
    ];
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: false,
      ordering: false,
      searching: false,

      ajax: (dataTablesParameters: any, callback) => {
        this.isLoading = true;

        const baseUrl = this.service.getUserServiceDetails(this.userId);

        this.http.get<any>(baseUrl).subscribe((resp) => {
          const list = resp.data || [];

          callback({
            recordsTotal: list.length,
            recordsFiltered: list.length,
            data: list,
          });

          this.isLoading = false;
        });
      },

      responsive: true,

      columns: [
        {
          title: "Sr.No.",
          data: null,
          render: (data, type, row, meta) => meta.row + 1,
        },

        {
          title: "State",
          data: "StateName",
          render: (data) => data || "",
        },

        {
          title: "Location",
          data: null,
          render: (data) => {
            if (!data.Location || !data.Location.length) return "—";

            return data.Location.map((loc) => {
              if (loc.CityID) {
                return `
                        <b>City:</b> ${loc.CityName || ""}<br>
                        <b>District:</b> ${loc.DistrictName || ""}
                    `;
              }

              if (loc.WardID) {
                return `
                        <b>Ward:</b> ${loc.WardName || ""}<br>
                        <b>City Survey Office:</b> ${
                          loc.CitySurveyOfficeName || ""
                        }<br>
                        <b>District:</b> ${loc.DistrictName || ""}
                    `;
              }

              return `
                    <b>Village:</b> ${loc.VillageName || ""}<br>
                    <b>Taluka:</b> ${loc.TalukaName || ""}<br>
                    <b>District:</b> ${loc.DistrictName || ""}
                `;
            }).join(
              '<hr style="margin:6px 0; border:0; border-top:2px solid #333;">'
            );
          },
        },

        {
          title: "Property Details",
          data: null,
          render: (data) => {
            if (!data.DynamicFields || !data.DynamicFields.length) return "—";

            return data.DynamicFields.filter(
              (f) =>
                f.label !== "Village or Pincode" &&
                f.label !== "Ward" &&
                f.label !== "City"
            )
              .map((f) => `<b>${f.label}:</b> ${f.value}<br>`)
              .join("");
          },
        },

        {
          title: "Services",
          data: null,
          render: (data) => {
            if (!data.Services || !data.Services.length) return "No Services";

            return data.Services.map(
              (s) => `
                <div class="service-block">
                    <span class="service-title"><b>${s.ServiceName}</b></span>
                    <div>
                        ${s.SubServices.map(
                          (sub) =>
                            `<span class="sub-chip">• ${sub.SubType_Name}</span><br>`
                        ).join("")}
                    </div>
                </div>
            `
            ).join("<hr>");
          },
        },

        {
          title: "Purpose",
          data: "PurposeNames",
          render: (data, type, row) => {
            if (!data) return "—";

            // Business rule: the "Others" purpose is free-text — show it as
            // "Others - <remark>" using the row's OtherPurpose value.
            const esc = (s) =>
              String(s)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
            const otherRemark =
              row && row.OtherPurpose ? String(row.OtherPurpose).trim() : "";

            const items = data
              .split(",")
              .map((d) => d.trim())
              .map((d) => {
                if (otherRemark && d.toLowerCase() === "others") {
                  return `<li>Others - ${esc(otherRemark)}</li>`;
                }
                return `<li>${d}</li>`;
              })
              .join("");

            return `<ul style="padding-left: 18px; margin: 0;">${items}</ul>`;
          },
        },

        {
          title: "Created Date",
          data: "CreatedDate",
          render: (data) => {
            return this.datePipe.transform(data, "dd/MM/yyyy", "IST") || "";
          },
        },
      ],
    };
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  openPropertyPopup(propertyId: number) {
    // this.dialog.open(ViewPropertyServicesComponent, {
    //     width: '600px',
    //     panelClass: 'premium-dialog',
    //     data: { PropertyID: propertyId },
    // });
  }

  getUsersCallDetails() {
    this.isLoading = true;
    this.service.getUsersCallDetails(this.userId).subscribe(
      (res: any) => {
        if (res) {
          this.usersData = res.data;
          this.isLoading = false;
        }
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    );
  }

  getCallAlertType() {
    this.isLoading = true;
    this.service.getCallAlertType().subscribe(
      (res: any) => {
        if (res) {
          this.callAlertTypes = res.data;
          this.isLoading = false;
        }
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    );
  }

  openDialog(): void {
    localStorage.setItem("UserId", this.userId);
    this.router.navigate(["users/users-users-details/services-interest/add"], {
      state: { UserId: this.userId },
    });
  }

  close() {
    this.dialog.closeAll();
  }
}
